import type { SchemaField } from '@cli-types/core-engine/schema.js'
import type { FieldRenderContext } from '@cli-types/next-adapter/forms.js'
import { fillControlClass } from '@next-adapter/generators/form/form-shared/fill-control-class.js'
import { formLabel } from '@next-adapter/generators/form/form-shared/form-label.js'
import { labelWithDescription } from '@next-adapter/generators/form/form-shared/label-with-description.js'
import { renderTextareaFieldRenderer } from '@next-adapter/templates/renderers/generators/form/field-jsx/render-textarea-field.js'
import { defaultValueFromSourceHandler } from './default-value-from-source-handler.js'
import { fillFormItemProps } from './fill-form-item-props.js'

export function renderTextareaField(
  field: SchemaField,
  indent: string,
  label: string,
  hintJSX: string,
  context: FieldRenderContext
): string {
  const defaultValueFromHandler = defaultValueFromSourceHandler(field, context)
  const fieldProps = defaultValueFromHandler
    ? renderTextareaFieldRenderer({
        kind: 'renderTextareaFieldChangeHandlerTemplate',
        props: {
          indent: indent,
          defaultValueFromHandler: defaultValueFromHandler
        }
      })
    : '{...formField}'
  return renderTextareaFieldRenderer({
    kind: 'renderTextareaFieldFormFieldTemplate',
    props: {
      indent: indent,
      fieldName: field.name,
      fillFormItemProps: fillFormItemProps(field),
      labelWithDescription: labelWithDescription(
        formLabel(field, label),
        hintJSX,
        `${indent}      `
      ),
      toLowerCase: label.toLowerCase(),
      fillControlClass: fillControlClass(field, 'min-h-[80px]'),
      fieldProps: fieldProps
    }
  })
}
